import Api from '../utils/Api';
import Config from '../config/Config';

class ObtenerFecha {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntity({ name: 'fecha' });
  }

  obtenerFecha(token) {
    const config = { headers: { 'token':token } };
    return this.api.endpoints.fecha
      .get(config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }
}

export default new ObtenerFecha;
